<div class="svg-icon" [ngClass]="name" [ngStyle]="style" [inlineSVG]="iconsPath + '/' + name + '.svg'" [onSVGLoaded]="onSVGLoaded"></div>